<template>
  <div
    class="page_container goodsManageSet"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >业务资源管理（客户管理）</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/resourceIndex/serviceIndex' }"
          >客户服务管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/resourceIndex/rServiceDetail' }"
          >客户详情</el-breadcrumb-item
        >
        <el-breadcrumb-item
          :to="{
            path: `/resourceIndex/addressList`,
          }"
          >客户物流管理</el-breadcrumb-item
        >
        <!-- <el-breadcrumb-item :to="{ path: '/resourceIndex/addressList/' + id }">客户物流管理</el-breadcrumb-item> -->
        <el-breadcrumb-item>客户物流详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!--  主要内容 start -->
    <div class="form_container">
      <h1>物流信息管理</h1>
      <div class="content_wrap flex-between">
        <div class="form_wrap">
          <div class="block">
            <p><span class="mark">*</span>姓名</p>
            <div class="input_box">
              <el-input
                v-model="formData.truename"
                placeholder="请输入姓名"
              ></el-input>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>手机号</p>
            <div class="input_box">
              <el-input
                v-model="formData.mobile"
                placeholder="请输入手机号"
              ></el-input>
            </div>
          </div>
          <div class="block">
            <p><span class="mark"></span>物流信息类型</p>
            <div class="input_box">
              <el-radio-group v-model="formData.runtype">
                <el-radio label="1">私人</el-radio>
                <el-radio label="2">办公</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>所在地区</p>
            <div class="select_box">
              <el-select
                v-model="formData.province"
                placeholder="选择省/直辖市"
                @visible-change="getProvince"
              >
                <el-option
                  v-for="item in provinceList"
                  :key="item.areaid"
                  :label="item.areaname"
                  :value="item.areaid"
                >
                </el-option>
              </el-select>
            </div>
            <div class="select_box">
              <el-select
                v-model="formData.city"
                placeholder="选择城市"
                @visible-change="getCity"
              >
                <el-option
                  v-for="item in cityList"
                  :key="item.cityid"
                  :label="item.cityname"
                  :value="item.cityid"
                >
                </el-option>
              </el-select>
            </div>
            <div class="select_box">
              <el-select
                v-model="formData.area"
                placeholder="选择所在区域"
                @visible-change="getArea"
              >
                <el-option
                  v-for="item in areaList"
                  :key="item.addrid"
                  :label="item.addrname"
                  :value="item.addrid"
                >
                </el-option>
              </el-select>
            </div>
            <div class="input_box">
              <el-input
                v-model="formData.addr"
                placeholder="请填写详细地址，50个字符内"
                type="textarea"
              ></el-input>
            </div>
          </div>
          <div class="block">
            <p><span class="mark"></span>是否默认</p>
            <div class="input_box">
              <el-radio-group v-model="formData.isdefault">
                <el-radio label="是">是</el-radio>
                <el-radio label="不是">不是</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="block">
            <p><span class="mark"></span>是否启用</p>
            <div class="input_box">
              <el-radio-group v-model="formData.isuse">
                <el-radio label="1">启用</el-radio>
                <el-radio label="0">停用</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form_footer flex-rowl">
      <div class="btn" @click="query">确认</div>
      <div class="return_txt" @click="handleReturn">←返回</div>
    </div>
    <!--  主要内容 end -->
  </div>
</template>
<script>
import {
  getProvince,
  getCity,
  getArea,
  encryptstringview,
} from "../../../api/api";
import {
  editCustomAddress,
  addCustomAddress,
  getCustomAddressDetail,
} from "../../../api/company";
import { mapState } from "vuex";
export default {
  name: "addressDetail",
  data() {
    return {
      id: "",
      loading: false,
      formData: {
        id: "",
        guid: "",
        province: "",
        city: "",
        area: "",
        addr: "",
        zipcode: "",
        isdefault: "不是", // 是否默认 =是 不是
        truename: "",
        mobile: "",
        runtype: "", // 物流信息类型 =1=私人 2=办公
        isuse: "0", // 是否启用 =1=启用 0=停用
      },
      provinceList: [],
      provinceTxtL: "",
      cityList: [],
      areaList: [],
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id, customerGuid, addressId } = JSON.parse(res.jsondata);
        this.id = id;
        this.formData.id =
          this.$route.params.addressId == 0 ? "" : addressId;
        this.formData.guid = customerGuid;
        this.getCustomAddressDetail();
      } else {
        this.$router.back();
      }
    },

    // 获取地址详情
    getCustomAddressDetail() {
      let params = {
        id: this.formData.id,
        guid: this.formData.guid,
      };
      getCustomAddressDetail(params).then((res) => {
        this.formData.truename = res.truename;
        this.formData.mobile = res.mobile;
        this.formData.isdefault = res.isdefault;
        this.formData.runtype = res.runtype;
        this.formData.isuse = res.isuse;
        this.formData.province = res.province ? parseInt(res.province) : "";
        this.formData.city = res.city ? parseInt(res.city) : "";
        this.formData.area = res.area ? parseInt(res.area) : "";
        this.formData.addr = res.addr;
        if (res.province) {
          this.getProvince(true);
          if (res.city) {
            this.getCity(true);
            if (res.area) {
              this.getArea(true);
            }
          }
        }
      });
    },
    // 获取城市
    getProvince(isClick) {
      getProvince().then((res) => {
        this.provinceList = res;
        if (!isClick) {
          this.formData.city = "";
          this.formData.area = "";
          this.cityList = [];
          this.areaList = [];
        }
      });
    },
    // 获取城市
    getCity(isClick) {
      getCity(this.formData.province).then((res) => {
        this.cityList = res;
        if (!isClick) {
          this.formData.area = "";
          this.areaList = [];
        }
      });
    },
    // 获取区域
    getArea() {
      getArea(this.formData.city).then((res) => {
        this.areaList = res;
      });
    },
    query() {
      let { formData } = this;
      if (formData.truename == "") {
        this.$message.warning("请输入姓名 ");
        return;
      }
      if (formData.mobile == "") {
        this.$message.warning("请输入手机号");
        return;
      }
      if (formData.province == "") {
        this.$message.warning("请选择地址");
        return;
      }
      if (formData.id == "") {
        this.addCustomAddress();
      } else {
        this.editCustomAddress();
      }
    },

    // 修改
    editCustomAddress() {
      this.loading = true;
      editCustomAddress(this.formData).then((res) => {
        if (res.result) {
          setTimeout(() => {
            this.loading = false;
            this.$router.back();
          }, 500);
        } else {
          this.loading = false;
          this.$message.error(res.message || "服务器报错，请稍后～");
        }
      });
    },

    // 新增
    addCustomAddress() {
      this.loading = true;
      addCustomAddress(this.formData).then((res) => {
        if (res.result) {
          setTimeout(() => {
            this.loading = false;
            this.$router.back();
          }, 500);
        } else {
          this.loading = false;
          this.$message.error(res.message || "服务器报错，请稍后～");
        }
      });
    },
    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  .form_container {
    .content_wrap {
      .form_wrap {
        margin-right: 100px;
      }
      .tip_wrap {
        flex: 1;
        .item {
          margin-bottom: 30px;
          color: #6e6e6e;
          h1 {
            margin-bottom: 8px;
            font-size: 18px;
          }
          p {
            font-size: 16px;
            margin-right: 20px;
          }
          .edit_wrap {
            height: 30px;
            .check_box {
              margin-right: 20px;
            }
            .select_box,
            .input_box {
              width: 200px;
            }
          }
        }
      }
    }
  }
}
</style>